// extracted by mini-css-extract-plugin
module.exports = {"root":"Top_root__3LbQL","wrapper":"Top_wrapper__2ilXY"};